import React, { useEffect } from 'react';
import {
    Dialog,
    Box,
    Typography,
} from '@mui/material';
import styles from './OnedayDragentifer.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { dragantigerSettlementResult, onedaydtresult } from '../../../store/slices/casinoResultsSlice';

const parseCard = (cardStr) => {
    if (!cardStr || typeof cardStr !== 'string') return { value: '-', suit: '' };
    const rank = cardStr.slice(0, -2);
    const suitCode = cardStr.slice(-2);
    const suitMap = {
        'HH': '♥',
        'DD': '♦',
        'CC': '♣',
        'SS': '♠',
    };
    return {
        value: rank || '-',
        suit: suitMap[suitCode] || suitCode,
    };
};

const TrophySVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
        <path d="M23.2038 15.5799L23.7874 18.9815L20.733 17.3755L17.6786 18.9815L18.2622 15.5799L15.791 13.1719L19.2058 12.6751L20.733 9.58105L22.2602 12.6751L25.675 13.1719L23.2038 15.5799Z" fill="#128400" />
        <path d="M26.2665 31.0526H15.2441C19.2745 29.0374 18.4809 24.6298 18.5605 25.1266L18.7933 25.169C19.0556 25.2549 19.3227 25.325 19.5933 25.379C19.9639 25.4535 20.3395 25.5006 20.7169 25.5198L20.7357 25.5234H20.7553H20.7749L20.7909 25.5206C21.169 25.5014 21.5452 25.4546 21.9165 25.3806C22.2539 25.313 22.5858 25.2207 22.9097 25.1046C22.8901 25.3694 22.5881 29.213 26.2665 31.0526Z" fill="#128400" />
        <path d="M27.076 32.09V35.0212H14.4336V32.09C14.4336 31.9561 14.46 31.8236 14.5112 31.6999C14.5625 31.5762 14.6376 31.4638 14.7323 31.3692C14.8269 31.2745 14.9393 31.1995 15.063 31.1483C15.1867 31.0971 15.3193 31.0707 15.4532 31.0708H26.0564C26.1903 31.0707 26.3228 31.0971 26.4465 31.1483C26.5702 31.1995 26.6827 31.2745 26.7773 31.3692C26.872 31.4638 26.9471 31.5762 26.9984 31.6999C27.0496 31.8236 27.076 31.9561 27.076 32.09Z" fill="#28D225" />
        <path d="M27.7938 20.6614C27.5584 20.6607 27.3309 20.577 27.1512 20.4251C26.9715 20.2731 26.8512 20.0627 26.8113 19.8308C26.7715 19.5988 26.8147 19.3603 26.9334 19.1571C27.052 18.9539 27.2386 18.7991 27.4602 18.7198C32.281 17.0142 33.1842 15.1366 33.8638 12.8598C34.0638 12.1842 34.0746 11.6526 33.8898 11.3234C33.8004 11.1687 33.6627 11.0477 33.4978 10.979L28.9186 10.9658C28.6533 10.9654 28.3991 10.8597 28.2119 10.6719C28.0246 10.4841 27.9196 10.2296 27.92 9.96442C27.9203 9.69921 28.026 9.445 28.2138 9.25772C28.4016 9.07045 28.6561 8.96545 28.9214 8.96582H28.9242L33.655 8.97942C33.7222 8.97965 33.7892 8.98662 33.855 9.00022C34.2154 9.08803 34.5548 9.24636 34.8538 9.46605C35.1527 9.68574 35.4051 9.96245 35.5966 10.2802C36.095 11.1138 36.1566 12.175 35.7814 13.4338C35.3878 14.7538 34.8538 16.1506 33.6214 17.4338C32.4058 18.7022 30.6614 19.7106 28.1266 20.607C28.0195 20.6438 27.907 20.6622 27.7938 20.6614Z" fill="#128400" />
        <path d="M13.7175 20.68C13.6044 20.6801 13.4921 20.6609 13.3855 20.6232C10.8327 19.724 9.0739 18.7136 7.8511 17.4428C6.6111 16.156 6.0767 14.754 5.6815 13.4304C5.3055 12.1716 5.3679 11.1104 5.8663 10.2768C6.05772 9.95904 6.31018 9.68232 6.60909 9.46263C6.90801 9.24294 7.24748 9.08462 7.6079 8.9968C7.67371 8.9832 7.74071 8.97623 7.8079 8.976L12.5823 8.9624H12.5855C12.8507 8.96203 13.1052 9.06703 13.293 9.25431C13.4808 9.44158 13.5865 9.69579 13.5869 9.961C13.5873 10.2262 13.4823 10.4807 13.295 10.6685C13.1077 10.8563 12.8535 10.962 12.5883 10.9624L7.9651 10.9756C7.80017 11.0443 7.66242 11.1653 7.5731 11.32C7.3883 11.6492 7.3975 12.1808 7.5991 12.8564C8.2791 15.1404 9.1887 17.0232 14.0507 18.7332C14.2736 18.8114 14.4616 18.966 14.5814 19.1695C14.7012 19.373 14.7451 19.6124 14.7053 19.8452C14.6656 20.078 14.5447 20.2892 14.3641 20.4414C14.1835 20.5936 13.9549 20.677 13.7187 20.6768L13.7175 20.68Z" fill="#128400" />
        <path d="M30.6342 6.9574C30.6238 6.2978 30.6126 5.6374 30.6126 4.979H10.8986C10.8986 5.6378 10.8874 6.299 10.8774 6.9574C10.8426 9.1574 10.815 11.3546 11.2306 13.5226C11.4309 14.5861 11.6913 15.6374 12.0106 16.6714C12.4146 17.9666 12.9266 19.2266 13.5798 20.4098C14.7482 22.5298 16.4742 24.4134 18.7938 25.1698L20.7174 25.5202L20.7574 25.5226H20.793L22.913 25.0914C22.913 25.0914 22.913 25.0974 22.913 25.1058C25.1338 24.3074 26.7962 22.4682 27.9306 20.4098C29.1066 18.2802 29.825 15.903 30.281 13.5226C30.6962 11.3546 30.6686 9.1574 30.6342 6.9574ZM23.7882 18.9814L20.7338 17.3758L17.6794 18.9814L18.263 15.5814L15.7918 13.173L19.2066 12.677L20.7338 9.5826L22.261 12.677L25.6758 13.173L23.2046 15.5802L23.7882 18.9814Z" fill="#28D225" />
    </svg>
);

const OneDayDragonTigerResultsPopup = ({ open, onClose, resultData }) => {

    const dragonCard = parseCard(resultData?.dragonCard);
    const tigerCard  = parseCard(resultData?.tigerCard);

    const roundId   = resultData?.roundId   || '-';
    const matchTime = resultData?.settledAt || '-';
    const winner    = resultData?.winner    || '-';

    const oddEven    = `D: ${resultData?.dragonParity || '-'} | T: ${resultData?.tigerParity || '-'}`;
    const color      = `D: ${resultData?.dragonColor  || '-'} | T: ${resultData?.tigerColor  || '-'}`;
    const totalColor = `D: ${resultData?.dragonSuit   || '-'} | T: ${resultData?.tigerSuit   || '-'}`;

    const isDragonWinner = winner?.toLowerCase() === 'dragon';
    const isTigerWinner  = winner?.toLowerCase() === 'tiger';
        const formatMatchTime = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const pad = (n) => String(n).padStart(2, '0');

  const day = pad(d.getDate());
  const month = pad(d.getMonth() + 1);
  const year = d.getFullYear();
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());
  const seconds = pad(d.getSeconds());

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={styles.betDialogOpen_container}
            PaperProps={{
                style: {
                    position: 'absolute',
                    top: 0,
                    backgroundColor: 'none !important',
                    width: '95%',
                    borderRadius: '0px'
                },
            }}
        >
            <Box className={styles.Dialog_header}>
                <Typography className={styles.betDialog_header_txt}>One Day Dragon Tiger Results</Typography>
                <span onClick={onClose} style={{ cursor: 'pointer' }}>
                    {/* close SVG same rehta */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <g clipPath="url(#clip0_6976_19069)">
                            <path d="M0.586047 12.0001C0.470144 12.0001 0.356837 11.9657 0.26046 11.9014C0.164083 11.837 0.0889654 11.7455 0.0446082 11.6384C0.000250996 11.5313 -0.0113527 11.4135 0.0112649 11.2998C0.0338824 11.1861 0.0897052 11.0817 0.171672 10.9998L10.9998 0.17164C11.1097 0.0617407 11.2588 0 11.4142 0C11.5696 0 11.7186 0.0617407 11.8285 0.17164C11.9384 0.281539 12.0002 0.430594 12.0002 0.586015C12.0002 0.741436 11.9384 0.890491 11.8285 1.00039L1.00042 11.8285C0.946056 11.883 0.881462 11.9262 0.810351 11.9556C0.739239 11.9851 0.663012 12.0002 0.586047 12.0001Z" fill="white" />
                            <path d="M11.4141 12.0001C11.3372 12.0002 11.2609 11.9851 11.1898 11.9556C11.1187 11.9262 11.0541 11.883 10.9998 11.8285L0.17164 1.00039C0.0617407 0.890491 0 0.741436 0 0.586015C0 0.430594 0.0617407 0.281539 0.17164 0.17164C0.281539 0.0617407 0.430594 0 0.586015 0C0.741436 0 0.890491 0.0617407 1.00039 0.17164L11.8285 10.9998C11.9105 11.0817 11.9663 11.1861 11.9889 11.2998C12.0115 11.4135 11.9999 11.5313 11.9556 11.6384C11.9112 11.7455 11.8361 11.837 11.7397 11.9014C11.6433 11.9657 11.53 12.0001 11.4141 12.0001Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_6976_19069">
                                <rect width="12" height="12" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </span>
            </Box>

            <Box className={styles.Dialog_body}>

                {/* Round ID & Match Time */}
                <Box className={styles.roundId_TextField_container}>
                    <Typography className={styles.roundId_TextField}>
                        Round ID: <br />{roundId}
                    </Typography>
                    <Typography className={styles.roundId_TextFieldmatchTime}>
                      Match Time: <br />
{formatMatchTime(matchTime)}
                    </Typography>
                </Box>

                {/* Dragon Card */}
                <Box className={styles.dragonCardPopup_container}>
                    <Typography className={styles.dragonCardPopup_txt}>DRAGON</Typography>
                    <Box className={styles.dragonCard_container}>
                        <Box className={styles.Cards_container}>
                            <Box sx={{ alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', display: 'flex', textAlign: 'center' }}>
                                <Typography className={styles.Cards_number}>{dragonCard.value}</Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: ['♥', '♦'].includes(dragonCard.suit) ? '#FF0000' : '#000', fontSize: '14px' }}>
                                    {dragonCard.suit}
                                </Typography>
                            </Box>
                        </Box>
                        {isDragonWinner && <TrophySVG />}
                    </Box>
                </Box>

                {/* Tiger Card */}
                <Box className={styles.dragonCardPopup_container}>
                    <Typography className={styles.dragonCardPopup_txt}>TIGER</Typography>
                    <Box className={styles.dragonCard_container}>
                        <Box className={styles.dragonCardPopup_card}>
                            <Box sx={{ alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', display: 'flex', textAlign: 'center' }}>
                                <Typography className={styles.Cards_number}>{tigerCard.value}</Typography>
                            </Box>
                            <Box>
                                <Typography sx={{ color: ['♥', '♦'].includes(tigerCard.suit) ? '#FF0000' : '#000', fontSize: '14px' }}>
                                    {tigerCard.suit}
                                </Typography>
                            </Box>
                        </Box>
                        {isTigerWinner && <TrophySVG />}
                    </Box>
                </Box>

                <Box sx={{ height: '1px', background: '#ddd', margin: '0 0 4px 0', width: '100%' }} />

                {/* Result Details */}
                <Box className={styles.dragonCardPopup_bottomcontainer}>
                    <Box className={styles.winner_boxcontainer}>
                        <Typography className={styles.winner_txt}>Winner:</Typography>
                        <Typography className={styles.winner_boldtxt}>{winner}</Typography>
                    </Box>
                    <Box className={styles.winner_boxcontainer}>
                        <Typography className={styles.winner_txt}>Odd/Even:</Typography>
                        <Typography className={styles.winner_boldtxt}>{oddEven}</Typography>
                    </Box>
                    <Box className={styles.winner_boxcontainer}>
                        <Typography className={styles.winner_txt}>Colour:</Typography>
                        <Typography className={styles.winner_boldtxt}>{color}</Typography>
                    </Box>
                    {/* <Box className={styles.winner_boxcontainer}>
                        <Typography className={styles.winner_txt}>Total:</Typography>
                        <Typography className={styles.winner_boldtxt}>{totalColor}</Typography>
                    </Box> */}
                </Box>

            </Box>
        </Dialog>
    );
};

export default OneDayDragonTigerResultsPopup;